interface IAppConfig {
  baseUrl?: string;
  authUrl?: string;
  signalRUrl?: string;
  webUrl?: string;
}

export const appConfig: IAppConfig = {
  baseUrl: import.meta.env.REACT_APP_BASE_API_URL,
  signalRUrl: import.meta.env.REACT_APP_SIGNAL_R_URL,
  authUrl: import.meta.env.REACT_APP_AUTH_URL,
  webUrl: import.meta.env.REACT_APP_WEB_URL,
};
